module.exports = __webpack_public_path__ + "static/paste-480f917196cf52866fffdf97b42d83dc.mp4";